/**
 * Siblings Collapse
 * Limits the siblings fieldset to 2 visible rows and adds a "Show all options" toggle.
 */
(function () {
  function initSiblingsCollapse() {
    document.querySelectorAll('.siblings-collapse-fieldset').forEach(function (fieldset) {
      if (fieldset.dataset.siblingsCollapseInit) return;
      fieldset.dataset.siblingsCollapseInit = 'true';

      var wrapper = fieldset.closest('.siblings-collapse-wrapper');
      if (!wrapper) return;

      // Measure the natural full height first (while unconstrained)
      var fullHeight = fieldset.scrollHeight;

      // Collect all sibling items to determine row heights
      var items = fieldset.querySelectorAll('.sibling-item');
      if (items.length === 0) return;

      // Calculate the height of 2 rows:
      // We need to find the y-offset of the first item in the 3rd row.
      var twoRowHeight = getTwoRowHeight(fieldset, items);

      // Only collapse if there are more items than fit in 2 rows
      if (fullHeight <= twoRowHeight + 4) {
        // Everything fits in 2 rows or less – nothing to do
        return;
      }

      // Apply collapsed state
      fieldset.style.maxHeight = twoRowHeight + 'px';
      fieldset.classList.add('is-collapsed');

      // Build toggle button
      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'siblings-collapse-toggle';
      toggle.setAttribute('aria-expanded', 'false');

      var label = wrapper.dataset.labelExpand || 'Toon alle opties';
      var labelCollapse = wrapper.dataset.labelCollapse || 'Minder opties tonen';

      toggle.innerHTML = '<span class="siblings-toggle-text">' + label + '</span><span class="siblings-toggle-icon"></span>';
      wrapper.appendChild(toggle);

      toggle.addEventListener('click', function () {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';

        if (expanded) {
          // Collapse
          fieldset.style.maxHeight = twoRowHeight + 'px';
          fieldset.classList.add('is-collapsed');
          toggle.classList.remove('is-expanded');
          toggle.setAttribute('aria-expanded', 'false');
          toggle.querySelector('.siblings-toggle-text').textContent = label;
        } else {
          // Expand
          fieldset.style.maxHeight = fullHeight + 'px';
          fieldset.classList.remove('is-collapsed');
          toggle.classList.add('is-expanded');
          toggle.setAttribute('aria-expanded', 'true');
          toggle.querySelector('.siblings-toggle-text').textContent = labelCollapse;
        }
      });
    });
  }

  /**
   * Determines the max-height to show exactly 2 rows of sibling items.
   * It iterates over items and finds the top offset of the first item
   * that belongs to a 3rd row.
   */
  function getTwoRowHeight(fieldset, items) {
    var fieldsetTop = fieldset.getBoundingClientRect().top;
    var rowTops = [];

    items.forEach(function (item) {
      var itemTop = Math.round(item.getBoundingClientRect().top - fieldsetTop);
      if (!rowTops.includes(itemTop)) {
        rowTops.push(itemTop);
      }
    });

    rowTops.sort(function (a, b) { return a - b; });

    if (rowTops.length <= 2) {
      // All items fit in 2 rows
      return fieldset.scrollHeight;
    }

    // Height = top of the 3rd row - a small gap (we use the gap from the fieldset style or fallback 8px)
    var gap = parseInt(getComputedStyle(fieldset).gap || getComputedStyle(fieldset).rowGap || '8', 10) || 8;
    return rowTops[2] - gap;
  }

  // Run on DOMContentLoaded and also after any dynamic content updates (e.g. theme editor)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSiblingsCollapse);
  } else {
    initSiblingsCollapse();
  }

  // Re-init on Shopify section load (theme editor)
  document.addEventListener('shopify:section:load', initSiblingsCollapse);

  // Re-init on resize (row wrapping can change)
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      // Reset all initialised fieldsets so they can be re-measured
      document.querySelectorAll('.siblings-collapse-fieldset[data-siblings-collapse-init]').forEach(function (fieldset) {
        delete fieldset.dataset.siblingsCollapseInit;
        fieldset.style.maxHeight = '';
        fieldset.classList.remove('is-collapsed');
        var wrapper = fieldset.closest('.siblings-collapse-wrapper');
        if (wrapper) {
          var oldToggle = wrapper.querySelector('.siblings-collapse-toggle');
          if (oldToggle) oldToggle.remove();
        }
      });
      initSiblingsCollapse();
    }, 200);
  });
})();

